<template>
    <div class="loginheader">
        <a href="/">
            <img src="../../assets/images/logo_h.png" alt="">
        </a>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped>
    .loginheader {
        background: url('../../assets//images/head_bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 12px 0;
        padding-left: 14%;
        display: flex;
        align-items: center;
    }
</style>